var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#087D22",
    stroke: "#087D22"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2634 5.96626C12.5993 5.61003 12.5746 5.05654 12.2081 4.73C11.8417 4.40345 11.2724 4.42752 10.9366 4.78375L6.68229 9.29586L5.09142 7.43984C4.77321 7.0686 4.2057 7.01844 3.82386 7.32781C3.44201 7.63718 3.39042 8.18892 3.70862 8.56016L5.95862 11.1852C6.12486 11.3791 6.36916 11.4938 6.62877 11.4998C6.88838 11.5057 7.13798 11.4024 7.31345 11.2163L12.2634 5.96626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.36b88a7feccbac4c3a25e9dcfcc8f6a9.svg";
export { ForwardRef as ReactComponent };